export const API_DETAILS = {
  URL: 'https://api.airtable.com/v0/appsJDi2s5AKLyf5z/Glossary%20Data',
  KEY: 'keyHsJP9sCMpQ1uhK',
};
